export default __webpack_public_path__ + "static/media/node-logo.539c9022.svg";